// extracted by mini-css-extract-plugin
export default {"container":"PageHeader_container__zoUqA","block":"PageHeader_block__Q87fr"};